<template>
  <div class="registration-header">
    <a v-if="!$screen.isMobile($mq)" :href="serverSideAppUrl" class="registration-header__logo">
      <img v-bind="logo" :width="32" :height="32">
    </a>
    <div v-if="!hideNav" class="registration-header__steps">
      <span 
        v-for="(step, index) in steps" 
        :key="step.id" 
        :class="{'selected': step.id === stepId, 'previous-clickable': isPreviousStepID(step.id) && !disableStepClicks}"
        @click="$emit('clicked-step-id', step.id)"
      >
        <template v-if="isPreviousStepID(step.id)">
          <i class="ddi ddi-circle-success" /> {{ step.name }}
        </template>
        <template v-else>
          {{ index + 1 }}. {{ step.name }}
        </template>
      </span>
    </div>
  </div>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'
import config from '@/config'
import logoSrc from '@/assets/img/logos/logo-donedone.svg'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */
import { IItemForSelection } from '@/api/types/response.types'

/* API */

export default defineComponent({
  name: 'RegistrationHeader',

  props: {
    steps: {
      type: Array as () => IItemForSelection[],
      default: (): IItemForSelection[] => [],
    },
    stepId: {
      type: Number,
      required: true,
    },
    disableStepClicks: {
      type: Boolean,
      default: false,
    },
    hideNav: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['clicked-step-id'],

  data() {
    return {
      logo: {
        src: logoSrc,
        alt: 'Logo DoneDone',
      },
      serverSideAppUrl: config.serverSideAppUrl,
    }
  },

  methods: {
    isPreviousStepID(id: number): boolean {
      return id < this.stepId
    },
  },
})
</script>

<style lang="scss">
.registration-header {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
  height: $navbar-mobile-height;
  padding: 0 15px;
  background-color: var(--color-general-white);
  border-bottom: solid 2px $color--gray-30;

  @media (min-width: $--sm) {
    height: $navbar-desktop-height;
    line-height: 62px;
  }

  &__logo {
    position: absolute;
    top: 0;
    left: 0;
    padding-left: 20px;
  }

  &__steps {
    > span {
      @include lettering--p;
      color: var(--color-text-third);
      padding: 0 10px;
      cursor: default;

      .ddi-circle-success {
        top: -1px;
      }

      &.selected {
        color: var(--color-text-secondary);
        font-weight: $bold;
      }

      &.previous-clickable {
        @include clickable-gray-color-states;
      }
    }
  }
}
</style>
